import React from 'react';
import {
	orderTransitions,
	StatusConfig,
} from '../components/StatusCard/StatusCard';
import { fetchWorkflowSubject } from '../services/workflowApi';

export function mergeWorkflowTransitions(
	base: StatusConfig,
	transitions: Record<string, string[]> | null,
	managed: boolean
): StatusConfig {
	if (!managed || !transitions) {
		return base;
	}

	const next: StatusConfig['transitions'] = {};
	for (const [from, targets] of Object.entries(transitions)) {
		next[from] = orderTransitions(
			base.steps,
			from,
			targets.map((to) => {
				const existing = base.transitions[from]?.find(
					(transition) => transition.to === to
				);
				if (existing) {
					return existing;
				}

				const step = base.steps.find((item) => item.key === to);
				return {
					to,
					label:
						to === 'CANCELED'
							? 'Annuler'
							: to === 'POSTPONED'
								? 'Reporter'
								: (step?.label ?? to),
					type: 'secondary',
				};
			})
		);
	}

	return { ...base, transitions: next };
}

export function useWorkflowStatusConfig(
	subject: string,
	base: StatusConfig
): StatusConfig {
	const [config, setConfig] = React.useState(base);

	React.useEffect(() => {
		const token = localStorage.getItem('token');
		if (!token) {
			return;
		}

		let cancelled = false;
		fetchWorkflowSubject(token, subject)
			.then((result) => {
				if (!cancelled) {
					setConfig(
						mergeWorkflowTransitions(base, result.transitions, result.managed)
					);
				}
			})
			.catch(() => {
				if (!cancelled) {
					setConfig(base);
				}
			});

		return () => {
			cancelled = true;
		};
	}, [subject, base]);

	return config;
}
